/**
 * gameTickerStyles.js — StyleSheet for GameTicker.
 * Extracted verbatim from components/GameTicker.jsx (god-file decomposition).
 */

import { Platform, StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  container: {
    width: '100%',
    zIndex: 9998,
    overflow: 'hidden',
  },
  blurContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.06)',
    overflow: 'hidden',
    position: 'relative',
  },
  blurContainerWeb: {
    backgroundColor: 'rgba(14, 14, 18, 0.94)',
  },
  gradientBg: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,0.4)',
  },
  controls: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: 12,
    paddingRight: 8,
    gap: 6,
    zIndex: 10,
  },
  controlBtn: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: 'rgba(255,255,255,0.08)',
    alignItems: 'center',
    justifyContent: 'center',
  },
  speedToggleBtn: {
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 6,
    backgroundColor: 'rgba(255,255,255,0.12)',
    minWidth: 32,
    alignItems: 'center',
    justifyContent: 'center',
  },
  speedToggleText: {
    fontSize: 10,
    fontWeight: '700',
    color: 'rgba(255,255,255,0.8)',
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  tickerWrapper: {
    flex: 1,
    overflow: 'hidden',
  },
  tickerContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  tickerItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    gap: 8,
    height: 28,
  },
  statusBadge: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
    gap: 4,
  },
  statusText: {
    fontSize: 9,
    fontWeight: '700',
    letterSpacing: 0.5,
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  leagueTag: {
    fontSize: 10,
    fontWeight: '600',
    color: 'rgba(255,255,255,0.4)',
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  teamsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  teamText: {
    fontSize: 12,
    fontWeight: '600',
    color: 'rgba(255,255,255,0.9)',
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
    maxWidth: 80,
  },
  vsText: {
    fontSize: 10,
    fontWeight: '500',
    color: 'rgba(255,255,255,0.4)',
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  liveScoreContainer: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(59, 130, 246, 0.12)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    borderWidth: 1,
    borderColor: 'rgba(59, 130, 246, 0.25)',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 8,
    minWidth: 55,
  },
  liveScoreInner: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  liveScoreText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#FFFFFF',
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
    textShadow: '0 1px 2px rgba(0,0,0,0.3)',
  },
  liveScoreDash: {
    fontSize: 12,
    fontWeight: '500',
    color: 'rgba(255,255,255,0.5)',
  },
  livePeriodText: {
    fontSize: 9,
    fontWeight: '600',
    color: 'rgba(147, 197, 253, 0.95)',
    textTransform: 'uppercase',
    letterSpacing: 0.5,
    marginTop: 2,
  },
  timeText: {
    fontSize: 10,
    fontWeight: '500',
    color: 'rgba(255,255,255,0.5)',
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  divider: {
    width: 1,
    height: 16,
    backgroundColor: 'rgba(255,255,255,0.1)',
    marginLeft: 8,
  },
  // ⭐ League section end divider - bolder to show section break
  leagueEndDivider: {
    width: 2,
    height: 24,
    backgroundColor: 'rgba(139, 92, 246, 0.5)',
    marginLeft: 12,
    marginRight: 4,
  },
  // ⭐ League section start divider container
  leagueDividerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 8,
    height: 28,
    gap: 6,
  },
  leagueDividerBar: {
    width: 20,
    height: 2,
    backgroundColor: 'rgba(139, 92, 246, 0.6)',
    borderRadius: 1,
  },
  leagueDividerBadge: {
    backgroundColor: 'rgba(139, 92, 246, 0.25)',
    paddingHorizontal: 10,
    paddingVertical: 3,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(139, 92, 246, 0.5)',
  },
  leagueDividerText: {
    fontSize: 10,
    fontWeight: '700',
    color: '#c4b5fd',
    letterSpacing: 0.5,
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  edgeFade: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: 80,
    zIndex: 5,
  },
  leftFade: {
    left: 70, // After the control buttons (speed toggle + collapse)
    backgroundColor: 'rgba(0,0,0,0.5)',
    ...(Platform.OS === 'web' ? {
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      maskImage: 'linear-gradient(to right, black 0%, black 60%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to right, black 0%, black 60%, transparent 100%)',
    } : {}),
  },
  rightFade: {
    right: 70, // Offset for right controls
    backgroundColor: 'rgba(0,0,0,0.5)',
    ...(Platform.OS === 'web' ? {
      backdropFilter: 'blur(8px)',
      WebkitBackdropFilter: 'blur(8px)',
      maskImage: 'linear-gradient(to left, black 0%, black 60%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to left, black 0%, black 60%, transparent 100%)',
    } : {}),
  },
  emptyState: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    paddingVertical: 4,
  },
  emptyText: {
    fontSize: 11,
    color: 'rgba(255,255,255,0.4)',
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  skeletonWrapper: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
  },
  controlsRight: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingRight: 10,
    paddingLeft: 4,
    gap: 6,
    zIndex: 10,
  },
  prevLeagueBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 8,
    backgroundColor: 'rgba(139, 92, 246, 0.2)',
    borderWidth: 1,
    borderColor: 'rgba(139, 92, 246, 0.3)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  prevLeagueLabel: {
    fontSize: 10,
    fontWeight: '600',
    color: '#c4b5fd',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  nextLeagueBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    paddingVertical: 4,
    paddingHorizontal: 8,
    borderRadius: 8,
    backgroundColor: 'rgba(139, 92, 246, 0.2)',
    borderWidth: 1,
    borderColor: 'rgba(139, 92, 246, 0.3)',
    ...(Platform.OS === 'web' && {
      cursor: 'pointer',
    }),
  },
  nextLeagueLabel: {
    fontSize: 10,
    fontWeight: '600',
    color: '#c4b5fd',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  leagueIndicator: {
    paddingVertical: 4,
    paddingHorizontal: 8,
  },
  currentLeagueText: {
    fontSize: 10,
    fontWeight: '500',
    color: 'rgba(255,255,255,0.4)',
    textTransform: 'uppercase',
    letterSpacing: 0.3,
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  // ⭐ SGP Cache Indicator Styles
  sgpIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    paddingHorizontal: 5,
    paddingVertical: 2,
    borderRadius: 4,
    backgroundColor: 'rgba(139, 92, 246, 0.15)',
    borderWidth: 1,
    borderColor: 'rgba(139, 92, 246, 0.25)',
  },
  sgpDot: {
    width: 5,
    height: 5,
    borderRadius: 2.5,
    backgroundColor: '#8B5CF6',
  },
  sgpIndicatorText: {
    fontSize: 8,
    fontWeight: '700',
    color: '#8B5CF6',
    letterSpacing: 0.3,
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
  // Loading more indicator styles
  loadingMoreIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 4,
  },
  loadingDot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    backgroundColor: '#8B5CF6',
  },
  // 🔴 LIVE filter button styles
  // 🔴 Per-game LIVE badge styles (mirrors sgpIndicator)
  liveIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    paddingVertical: 2,
    paddingHorizontal: 5,
    borderRadius: 4,
    backgroundColor: 'rgba(16, 185, 129, 0.15)',
    borderWidth: 1,
    borderColor: 'rgba(16, 185, 129, 0.4)',
    marginLeft: 4,
    ...(Platform.OS === 'web' && { cursor: 'pointer' }),
  },
  liveBadgeDot: {
    width: 5,
    height: 5,
    borderRadius: 3,
    backgroundColor: '#10B981',
  },
  liveIndicatorText: {
    fontSize: 8,
    fontWeight: '800',
    color: '#10B981',
    letterSpacing: 0.5,
    fontFamily: Platform.OS === 'web' ? "Slate, -apple-system, system-ui" : 'System',
  },
});
